export const WageEN =
    {
        "wageTable": "Wage table",
        "wage": "Wage table",
        "wageReportTax": "Report tax",
        "wageRecipe": "Wage recipe",
        "wageReport": "Wage report",
        "wageTemplate": "Wage template",
        "wageNotify": "Send",
    }
